// Cart-level date math. The server enforces the 7-day weekly floor at
// quote time; the cart only uses these helpers to render a friendly
// duration + estimated subtotal so customers have a real number to
// react to before checkout.

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export function isIsoDate(value: string | null | undefined): value is string {
  return typeof value === "string" && ISO_DATE.test(value);
}

// Days inclusive between two ISO dates (Jun 2 → Jun 8 is 7 days). Returns
// null if either input is missing / malformed or the range is inverted.
export function inclusiveDays(start: string | null | undefined, end: string | null | undefined): number | null {
  if (!isIsoDate(start) || !isIsoDate(end)) return null;
  const s = new Date(`${start}T00:00:00`);
  const e = new Date(`${end}T00:00:00`);
  const days = Math.round((e.getTime() - s.getTime()) / 86_400_000) + 1;
  return days >= 1 ? days : null;
}

// Whole weeks billed for a given inclusive-day count. Rentals always bill
// in 7-day cycles so day 8 starts a second weekly cycle.
export function weeksBilled(days: number | null): number | null {
  if (days == null || days < 1) return null;
  return Math.max(1, Math.ceil(days / 7));
}

export function formatRangePretty(start: string, end: string): string {
  const s = new Date(`${start}T00:00:00`);
  const e = new Date(`${end}T00:00:00`);
  const sameYear = s.getFullYear() === e.getFullYear();
  const fmt = (d: Date, withYear: boolean): string =>
    d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      ...(withYear ? { year: "numeric" } : {}),
    });
  return `${fmt(s, false)} – ${fmt(e, !sameYear)}`;
}
